import {UserDto} from '../users/user.dto';

export class LoggedUserDto {
  user: UserDto;
  accessToken: string;
  refreshToken: string;
}
